import React from "react";

export type ModalStore = {
  modal: {
    open: boolean;
    body: React.ReactNode | null;
    size?: "small" | "medium" | "large" | string;
  };
  openModal: (body: React.ReactNode, size?: ModalStore["modal"]["size"]) => void;
  closeModal: () => void;
};

export const createModalStore = (set: any, _get: any): ModalStore => ({
  modal: { open: false, body: null, size: undefined },

  openModal: (body, size) =>
    set((state: any) => ({
      modalStore: {
        ...state.modalStore,
        modal: { open: true, body, size },
      },
    })),

  closeModal: () =>
    set((state: any) => ({
      modalStore: {
        ...state.modalStore,
        modal: { open: false, body: null, size: undefined },
      },
    })),
});